import React, { FC } from 'react'
import {
	InterfaceElementModel,
	interfaceElementSlice,
	interfaceElementsSelector,
	TitlesIE,
} from 'Pages/interfaceElement'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'Src/hooks'
import { notifySlice } from 'Modules'
import { Popconfirm } from 'antd'
import { TooltipComponent, UIPlacement } from 'LibNeo'
import { BlockButtons, IconStyled } from './styled'

interface ComponentProps {
	item: InterfaceElementModel
}

const actions = {
	updateIE: interfaceElementSlice.actions.updateOne,
	deleteIE: interfaceElementSlice.actions.deleteOne,
	setEditId: interfaceElementSlice.actions.setEditId,
	setDataItem: interfaceElementSlice.actions.setDataItem,
	showMessage: notifySlice.actions.showNotify,
}

export const CustomColumnActions: FC<ComponentProps> = ({ item }) => {
	const { updateIE, deleteIE, setEditId, setDataItem, showMessage } = useAppDispatch(actions)
	const editId = useSelector(interfaceElementsSelector.getEditId)
	const dataItem = useSelector(interfaceElementsSelector.getDataItem)
	const interfaceElements = useSelector(interfaceElementsSelector.getAll)

	const handleClose = () => {
		setEditId(null)
		setDataItem({})
	}

	const saveIE = () => {
		let result = true
		if (dataItem.parent_element_id) {
			const parentElementId = +dataItem.parent_element_id
			const parent_element = interfaceElements.entries.find(
				(el): boolean => parentElementId === el.id
			)
			if (parent_element && parent_element.parent_element_id) {
				result = false
				showMessage({ title: 'Нельзя создавать меню третьего уровня' })
			}
		}
		if (result) {
			updateIE({ interfaceElement: { ...item, ...dataItem }, id: item.id })
			handleClose()
		}
	}

	const handleEdit = () => setEditId(item?.id)

	return (
		<BlockButtons>
			<TooltipComponent title="Изменить" placement={UIPlacement.TOP}>
				<div>
					<IconStyled name="edit" onClick={handleEdit} disabled={editId === item.id} />
				</div>
			</TooltipComponent>
			{editId === item.id && (
				<>
					<TooltipComponent title="Сохранть" placement={UIPlacement.TOP}>
						<div>
							<IconStyled name="save" onClick={saveIE} />
						</div>
					</TooltipComponent>
					<TooltipComponent title="Отменить" placement={UIPlacement.TOP}>
						<div>
							<IconStyled name="close" onClick={handleClose} />
						</div>
					</TooltipComponent>
				</>
			)}
			<TooltipComponent title="Удалить" placement={UIPlacement.TOP}>
				<div>
					<Popconfirm
						title={TitlesIE.SURE}
						onConfirm={() => deleteIE(item.id)}
						okText={TitlesIE.DELETE}
						cancelText={TitlesIE.CANCEL}
					>
						<IconStyled name="trash" />
					</Popconfirm>
				</div>
			</TooltipComponent>
		</BlockButtons>
	)
}
